import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import IsometricGarage from './IsometricGarage';

function MiniMap({ color }: { color: string }) {
  return (
    <svg viewBox="0 0 120 64" className="w-full h-16" aria-hidden="true">
      <rect width="120" height="64" rx="8" fill="#f1f5f9" />
      <path d="M8 56 L8 30 L40 30 L40 10 L112 10" stroke="#cbd5e1" strokeWidth="6" fill="none" strokeLinecap="round" />
      <path d="M8 56 L8 30 L40 30 L40 10 L112 10" stroke={color} strokeWidth="3" fill="none" strokeLinecap="round" strokeDasharray="5 5" />
      <circle cx="8" cy="56" r="4" fill={color} />
      <circle cx="112" cy="10" r="4" fill={color} />
    </svg>
  );
}

function ExitCard({
  label,
  time,
  sub,
  color,
}: {
  label: string;
  time: string;
  sub: string;
  color: string;
}) {
  return (
    <div className="rounded-2xl bg-white border border-gray-100 shadow-sm p-5">
      <span className="text-xs font-bold uppercase tracking-wider" style={{ color }}>
        {label}
      </span>
      <div className="mt-2 text-4xl font-extrabold" style={{ color }}>
        {time}
      </div>
      <p className="mt-1 text-sm text-gray-500">{sub}</p>
      <div className="mt-4">
        <MiniMap color={color} />
      </div>
    </div>
  );
}

export default function WhyDirectionMatters() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="rounded-3xl bg-gray-50 border border-gray-100 p-6 sm:p-10">
          <div className="grid lg:grid-cols-[1fr_1fr_1fr] gap-8 items-center">
            {/* left text */}
            <div>
              <h2 className="text-3xl font-bold tracking-tight text-gray-900">
                Why direction matters.
              </h2>
              <p className="mt-4 text-gray-500 leading-relaxed">
                The same garage. Different exit. Big difference in your drive home.
              </p>
              <Link
                to="/methodology"
                className="mt-5 inline-flex items-center gap-1 text-sm font-semibold"
                style={{ color: '#17A24A' }}
              >
                See how it works
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>

            {/* center: north exit + garage graphic */}
            <div className="flex flex-col items-center gap-4">
              <ExitCard
                label="North Exit"
                time="4 min"
                sub="Fastest way home"
                color="#17A24A"
              />
              <div className="w-28 h-28">
                <IsometricGarage className="w-full h-full" upArrow downArrow />
              </div>
            </div>

            {/* right: south exit */}
            <div>
              <ExitCard
                label="South Exit"
                time="22 min"
                sub="Expect heavy delays"
                color="#F39C12"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
